export enum SendInvoiceBy {
    email = 'email',
    post = 'post',
}
